module.exports = __webpack_public_path__ + "img/02_no.3f62ae5a.svg";